import { Box, Grid } from "@mui/material";
import dayjs from "dayjs";
import { getToday } from "src/lib/date.helper";
import useIntervalTabsStore from "src/store/intervalTabs.store";

import { IntervalTab } from "./enum/IntervalTab";
import IntervalTabs from "./IntervalTabs";
import DatePickerCustom from "../DatePickerCustom/DatePickerCustom";
import SectionTitleWrapper from "../SectionWrapper/SectionWrapper";

const styles = {
  fullWidth: { xs: 12 },

  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: { xs: 2, md: 1, sm: 1 },
    flexWrap: { xs: "wrap", md: "nowrap" },
  },

  mobileTitleRow: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    order: { xs: 1, md: 1 },
  },

  mobileDatePicker: {
    display: { xs: "block", md: "none" },
  },

  desktopRightBox: {
    marginBottom: 2,
    minWidth: { xs: 0, sm: 0 },
    flexShrink: { xs: 1, sm: 1, md: 0 },
    display: { xs: "none", md: "flex" },
    alignItems: "center",
    gap: 2,
    flexDirection: "row",
    flexWrap: { xs: "wrap", md: "nowrap" },
    justifyContent: "flex-end",
    width: { xs: "auto", md: "auto" },
    order: 2,
  },

  datePickerWrapper: {
    order: { xs: 1, md: 3 },
    width: { xs: "auto", md: "auto" },
  },

  intervalTabsWrapper: {
    order: { xs: 2, md: 2 },
    width: { xs: "100%", md: "auto" },
  },

  mobileTabs: {
    display: { xs: "block", md: "none" },
    width: "100%",
    order: { xs: 2, md: 3 },
    mb: 2,
  },
};

function IntervalTabsWrapper({ componentId, title, children }: { children: React.ReactNode; componentId: string; title: string }) {
  const { componentStates, setDate } = useIntervalTabsStore();
  const componentState = componentStates[componentId] ?? { selectedTab: IntervalTab.Day };
  const selectedDate = componentStates[componentId]?.selectedDate ? dayjs(componentStates[componentId].selectedDate) : getToday();

  return (
    <Grid size={styles.fullWidth} mt={2}>
      <Grid sx={styles.topRow}>
        <Box sx={styles.mobileTitleRow}>
          <SectionTitleWrapper title={title} children={undefined} />

          <Box sx={styles.mobileDatePicker}>
            <DatePickerCustom
              variant={componentState.selectedTab}
              value={selectedDate}
              onChange={(newValue) => newValue && setDate(componentId, newValue.toISOString())}
            />
          </Box>
        </Box>

        <Box sx={styles.desktopRightBox}>
          <Box sx={styles.datePickerWrapper}>
            <DatePickerCustom
              variant={componentState.selectedTab}
              value={selectedDate}
              onChange={(newValue) => newValue && setDate(componentId, newValue.toISOString())}
            />
          </Box>

          <Box sx={styles.intervalTabsWrapper}>
            <IntervalTabs selectedTab={componentState.selectedTab} componentId={componentId} />
          </Box>
        </Box>

        <Box sx={styles.mobileTabs}>
          <IntervalTabs selectedTab={componentState.selectedTab} componentId={componentId} />
        </Box>
      </Grid>

      {children}
    </Grid>
  );
}

export default IntervalTabsWrapper;
